import { PROJECT_NAMESPACE } from 'common';
import { getAppConfigSetting } from '../../utils';

export const NAMESPACE = `${PROJECT_NAMESPACE}/Login`;

export const SET_APEX_USER_CHECKED = `${NAMESPACE}/SET_APEX_USER_CHECKED`;

//this is important and must be supplied when calling legit actions{
export const LEGIT_SERVICE_CONFIG = {
  useSessionLogin: false,
  apiUrl: getAppConfigSetting('legitUrl'),
};



// WEBPACK FOOTER //
// ./src/containers/Login/constants.js